import { Routes } from '@angular/router';
import { HomeComponent } from './page/home/home.component';
import { ProductDetailComponent } from './page/product-detail/product-detail.component';
import { ShopComponent } from './page/shop/shop.component';
import { CartComponent } from './page/cart/cart.component';
import { ContactComponent } from './page/contact/contact.component';
import { AboutComponent } from './page/about/about.component';
import { ChangePasswordComponent } from './page/change-password/change-password.component';
import { AdministratorComponent } from './page/admin/administrator/administrator.component';


export const routes: Routes = [
    {path: 'home', component: HomeComponent},
    {path: 'detail/:id', component: ProductDetailComponent},
    {path: 'shop', component: ShopComponent},
    {path: 'cart', component: CartComponent},
    {path: 'cart/:estado', component: CartComponent},
    {path: '', component: HomeComponent},
    {path: 'contact', component: ContactComponent},
    {path: 'about', component: AboutComponent},
    {path: 'changePassword', component: ChangePasswordComponent},
    {path: 'admin', component: AdministratorComponent},
];
